import {
    GET_PENDING_SUMMARY_REQUEST,
    GET_PENDING_SUMMARY_SUCCESS,
    GET_PENDING_SUMMARY_ERROR,
  } from "../actions/types";
  
  export const getPendingSummaryReducer = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_PENDING_SUMMARY_REQUEST:
        return {
          loading: true,
        };
      case GET_PENDING_SUMMARY_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_PENDING_SUMMARY_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  